import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TEXT_CONSTANTS } from '../constance/constants';

import { environment } from '../../environments/environment';
import { ApiService } from '../../services/apiservice';
import { HttpHeaders } from '@angular/common/http';
import { InsightsService } from '../../services/appinsightsservice';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { EnrollmentResponseComponent } from '../enrollment-response/enrollment-response.component';
import { Title } from '@angular/platform-browser';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-enroll-paslite',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ProgressSpinnerModule,
    ToastModule,
    EnrollmentResponseComponent,
    CardModule,
    DialogModule
  ],
  templateUrl: './enroll-paslite.component.html',
  styleUrl: './enroll-paslite.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class EnrollPasliteComponent implements OnInit {
  region: string = '';
  showPopup: boolean = false;
  apiResponse: any;
  siteKey = environment.recaptcha.siteKey;
  phoneMeterNumber: string = '';
  houseNumber: string = '';
  emailId: string = '';
  phoneNumberText: string = '';
  phoneNumberCall: string = '';
  acaptchaToken: string = '';
  alertPreferences = {
    email: false,
    textMessage: false,
    phoneCall: false,
  };
  customerIdentifierType: string = '';
  isPhoneOrMeterValid: boolean = false;
  isHouseNumValid: boolean = false;
  isEmailIdValid: boolean = false;
  isPhoneTextValid: boolean = true;
  isPhoneCallValid: boolean = true;
  ispasLightPreferenceForm: boolean = false;
  phoneOrMeterErrorMessage: string = '';
  houseNumberErrorMessage: string = '';
  emailError: string = '';
  phoneTextError: string = '';
  phoneCallError: string = '';
  responseMessage: string = '';
  responseStatus: string = '';
  isLoading: boolean = false;
  response: any[] = [];
  supportNumber: string = '';
  isEnableAsync: boolean = false;
  accountNumber = '';
  email = '';
  accountHelpVisible = false;
  accountHelpImage = '';
  accountHelpTitle = '';
  constructor(
    private apiService: ApiService,
    private insightsService: InsightsService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.region = params['region'];
    });
    this.supportNumber =
      environment.supportNumbers[
      this.region.toLowerCase() as keyof typeof environment.supportNumbers
      ] ?? environment.supportNumbers.default;
    this.titleService.setTitle('Power Alert Service®');
    this.fetchPageData();
  }

  textConstants = TEXT_CONSTANTS;

  private getRecaptchaToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      if ((window as any).grecaptcha && (window as any).grecaptcha.enterprise) {
        (window as any).grecaptcha.enterprise.ready(() => {
          (window as any).grecaptcha.enterprise
            .execute(this.siteKey, { action: 'submit' })
            .then(
              (token: string) => {
                this.acaptchaToken = token;
                resolve(token);
              },
              (error: any) => reject(error),
            );
        });
      } else {
        reject(new Error('reCAPTCHA not loaded'));
      }
    });
  }

  private fetchPageData(): void {
    let isRegionTx = this.region.toLowerCase() === 'texas';
    this.apiService
      .get(environment.apiUrl + '/api/PASLight/GetPASPageDetails')
      .subscribe((data: any) => {
        if (data) {
          this.isEnableAsync = data.enrollAsyncFlag === 'True';
        }
      });
  }

  validatePhoneOrMeterNumber(): boolean {
    let input = this.phoneMeterNumber.trim().toUpperCase();
    //check if it is a valid meter number
    const regex = /^[A-Za-z]\d{0,10}$/;
    if (regex.test(input)) {
      this.phoneMeterNumber = input;
      this.customerIdentifierType = 'M';
      this.phoneOrMeterErrorMessage = '';
      this.isPhoneOrMeterValid = true;
      this.validateForm();
      return true;
    }

    //else treat it as phone number and remove all non-numeric characters
    let cleanedInput = input.replace(/\D/g, '');
    this.phoneMeterNumber = cleanedInput;
    if (cleanedInput.length === 10) {
      this.customerIdentifierType = 'P';
      this.phoneOrMeterErrorMessage = '';
      this.isPhoneOrMeterValid = true;
      this.validateForm();
      return true;
    }
    this.isPhoneOrMeterValid = false;
    this.phoneOrMeterErrorMessage =
      this.region.trim().toUpperCase() === 'TEXAS'
        ? this.textConstants.ERROR_MESSAGES.INVALID_PHONEORMETERNUM_MESSAGETX
        : this.textConstants.ERROR_MESSAGES.INVALID_PHONEORMETERNUM_MESSAGEIN;
    this.validateForm();
    return false;
  }

  validateHouseNum(): boolean {
    this.houseNumber = this.houseNumber.replace(/[^a-zA-Z0-9]/g, '');
    if (!this.houseNumber.trim()) {
      this.isHouseNumValid = false;
      this.houseNumberErrorMessage =
        this.textConstants.ERROR_MESSAGES.REQUIRE_HOUSENUM_MESSAGE;
      this.validateForm();
      return false;
    }
    this.isHouseNumValid = true;
    this.houseNumberErrorMessage = '';
    this.validateForm();
    return true;
  }
  validateEmail(): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    this.isEmailIdValid = emailRegex.test(this.emailId);
    this.emailError = this.textConstants.ERROR_MESSAGES.INVALID_EMAIL;
    this.validateForm();
    return this.isEmailIdValid;
  }
  validatePhoneText(): boolean {
    if (this.alertPreferences.textMessage) {
      const phoneRegex = /^\d{10}$/;
      this.isPhoneTextValid = phoneRegex.test(this.phoneNumberText);
      this.phoneTextError = this.isPhoneTextValid
        ? ''
        : this.textConstants.ERROR_MESSAGES.INVALID_PHONE;
      this.validateForm();
      return this.isPhoneTextValid;
    } else {
      this.phoneNumberText = '';
      this.isPhoneTextValid = true;
      this.phoneTextError = '';
      this.validateForm();
      return true;
    }
  }
  validatePhoneCall(): boolean {
    if (this.alertPreferences.phoneCall) {
      const phoneRegex = /^\d{10}$/;
      this.isPhoneCallValid = phoneRegex.test(this.phoneNumberCall);
      this.phoneCallError = this.isPhoneCallValid
        ? ''
        : this.textConstants.ERROR_MESSAGES.INVALID_PHONE;
      this.validateForm();
      return this.isPhoneCallValid;
    } else {
      this.phoneNumberCall = '';
      this.isPhoneCallValid = true;
      this.phoneCallError = '';
      this.validateForm();
      return true;
    }
  }

  async onSubmit(form: NgForm, triggerEvent?: Event): Promise<void> {
    if (triggerEvent && !triggerEvent.isTrusted) {
      return;
    }

    try {
      await this.getRecaptchaToken();
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Failure',
        detail:
          'Unfortunately, your request could not be processed. Please try again.',
        life: environment.appSettings.snakbarLife,
      });
      return;
    }

    if (this.acaptchaToken) {
      const payload = {
        region: this.region.trim().toUpperCase() == 'TEXAS' ? 'TX' : 'IN',
        phoneMeterNumber: this.phoneMeterNumber,
        identifierType: this.customerIdentifierType,
        houseNumber: this.houseNumber,
        emailId: this.emailId,
        textPhoneNumber: this.phoneNumberText,
        callPhoneNumber: this.phoneNumberCall,
        token: this.acaptchaToken,
      };
      this.insightsService.trackEvent(
        `enrollPasliteSubmit: ${JSON.stringify(payload)}`,
      );
      this.isLoading = true;
      let enrollmentURL = this.isEnableAsync
        ? '/api/PASLight/GetAsyncAccountDetails'
        : '/api/PASLight/GetAccountDetails';
      this.apiService
        .post(environment.apiUrl + enrollmentURL, payload)
        .subscribe({
          next: (data: any) => {
            this.insightsService.trackEvent(
              `enrollPasliteResponse: ${JSON.stringify(data)}`,
            );
            //this.showPopup = true;
            const toastMessage = data.statusDescription
              ? data.statusDescription
              : environment.appMessages.unknownError + this.supportNumber;

            if (data.status == 'Success') {
              this.messageService.add({
                severity: 'success',
                summary: 'Enrollment Successful',
                detail: toastMessage,
                life: environment.appSettings.snakbarLife,
              });
            } else if (data.status == 'PartialFailed') {
              this.messageService.add({
                severity: 'success',
                summary: 'Enrollment partially successful',
                detail: toastMessage,
                life: environment.appSettings.snakbarLife,
              });
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Enrollment Failed',
                detail: toastMessage,
                life: environment.appSettings.snakbarLife,
              });
            }
            this.apiResponse = data;
            this.isLoading = false;
            this.refreshRecaptchaToken();
          },
          error: (error: any) => {
            console.error('API Error:', error);
            this.insightsService.trackEvent(
              `enrollPasliteError: ${JSON.stringify(error)}`,
            );
            this.messageService.add({
              severity: 'error',
              summary: 'Enrollment Failed',
              detail: environment.appMessages.unknownError + this.supportNumber,
              life: environment.appSettings.snakbarLife,
            });
            this.isLoading = false;
            this.refreshRecaptchaToken();
          },
        });
    } else {
      console.log("Token failure form Not Submitted");
      this.messageService.add({
        severity: 'error',
        summary: 'Failure',
        detail:
          'Unfortunately, your request could not be processed. Please try again.',
        life: environment.appSettings.snakbarLife,
      });
      this.refreshRecaptchaToken();
    }
  }

  handleSubmitButtonClick(event: MouseEvent, form: NgForm): void {
    if (!event.isTrusted) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    void this.onSubmit(form, event);
  }

  onReset(form: NgForm): void {
    this.phoneMeterNumber = '';
    this.phoneNumberCall = '';
    this.phoneNumberText = '';
    this.customerIdentifierType = '';
    this.houseNumber = '';
    this.alertPreferences = {
      email: false,
      textMessage: false,
      phoneCall: false,
    };
    form.resetForm();
  }

  validateForm() {
    if (
      this.isEmailIdValid &&
      this.isHouseNumValid &&
      this.isPhoneCallValid &&
      this.isPhoneTextValid &&
      this.isPhoneOrMeterValid
    ) {
      this.ispasLightPreferenceForm = true;
    } else {
      this.ispasLightPreferenceForm = false;
    }
  }

  refreshRecaptchaToken(): void {
    this.showPopup = false;
    this.acaptchaToken = '';
  }

  onCheckboxChange(event: any, checkboxType: string) {
    const isChecked = event.target.checked;
    if (!isChecked) {
      if (checkboxType == 'call') {
        this.phoneNumberCall = '';
        this.isPhoneCallValid = true;
        this.phoneCallError = '';
      } else {
        this.phoneNumberText = '';
        this.isPhoneTextValid = true;
        this.phoneTextError = '';
      }
      this.validateForm();
    }
  }


  isValidAccountNumber(): boolean {
    return /^\d{6}-\d$/.test(this.accountNumber);
  }
  isValidHouseNumber(): boolean {
    return /^\d{6}-\d$/.test(this.houseNumber);
  }
  isValidEmail(): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
  }
  openAccountHelp(helpType: 'meter' | 'street'): void {
    if (helpType === 'meter') {
      this.accountHelpImage = `../../assets/images/meternumber_${this.region.toLowerCase() === 'texas' ? 'tx' : 'in'}.jpg`;
      this.accountHelpTitle = 'Find Your Meter Number';
    } else {
      this.accountHelpImage = '../../assets/images/streetnumber.jpg';
      this.accountHelpTitle = 'Find Your Street Number';
    }
    this.accountHelpVisible = true;
  }
}
